export enum JobStatus {
	SUCCESS = 'success',
	FAILED = 'failed',
	PENDING = 'pending',
	CHAINED = 'chained',
}
